import React from "react";
import ProductSimilar from "../Components/similar/ProductSimilar";
import Spacer2 from "../Components/common/Spacer2";
import PageHeader from "../Components/common/PageHeader";
import { useTranslation } from "react-i18next";
import SEO from "../Components/common/SEO";

function ProductSimilarPage() {
  const { t } = useTranslation();
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/ProductSimilar`;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    'name': 'Benzer Ürünler',
    'url': pageUrl,
    'mainEntity': {
      '@type': 'ItemList',
      'name': 'Benzer Ürünler',
      'itemListElement': [
        { '@type': 'Product', 'name': 'Çamaşır Suyu', 'url': `${siteUrl}/camasirsuyu` },
        { '@type': 'Product', 'name': 'B. Deterjanı (Lüks)', 'url': `${siteUrl}/bulasikdeterjaniluks` },
        { '@type': 'Product', 'name': 'Sıvı El Sabunu', 'url': `${siteUrl}/sivielsabunu` }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Benzer Ürünler | Seymen Kimya"
        description="Seymen Kimya benzer ürünleri ve kombinlerini keşfedin."
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/product/products-collection.webp`}
        structuredData={structuredData}
      />
      <PageHeader title={t("BENZER ÜRÜNLER")} />
      <Spacer2 />
      <ProductSimilar />
    </>
  );
}

export default ProductSimilarPage;
